import angular from 'angular'

import template from '../../../templates/sale/wr-display-sale-discount.html'

/**
 * Directive for the display sale discount
 *
 * @module webregister.directives.wrDisplaySaleDiscount
 */
angular
  .module('webregister.directives')
  .directive('wrDisplaySaleDiscount', function () {
    return {
      restrict: 'E',
      scope: {
        sale: '=',
        customClasses: '=',
      },
      template,
    }
  })
